<template>
	<i class="afis-icon-iball" :iball="tag" v-tooltip="{ content, html: true }"/>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: ['tag', 'boundary'],
	computed: {
		...mapGetters(['IBallDescriptions']),
		content() {
			let description = '';
			if (this.IBallDescriptions) {
				description = this.IBallDescriptions[this.tag] || '';
			}
			return description;
		},
		boundaryElement() {
			return this.boundary
				? document.querySelector(this.boundary)
				: document.querySelector('#popper-boundary') ||
						document.querySelector('body');
		}
	},
	mounted() {
		this.$EventBus.$emit('additional-iball-mounted');
	},
	methods: {
		appendArrowOverlay() {
			//workaround for an issue with the modal not showing becuse of a stacking context issue
			if (this.$route.name === 'Returns') {
				this.$el.closest('td').style = 'z-index:10;';
			}
			this.$nextTick(() => {
				this.$nextTick(() => {
					const overlay = document.createElement('div');
					overlay.classList.add('arrow-overlay');
					while (this.$refs.popper.childNodes[1].firstChild) {
						this.$refs.popper.childNodes[1].removeChild(
							this.$refs.popper.childNodes[1].firstChild
						);
					}
					this.$refs.popper.childNodes[1].appendChild(overlay);
				});
			});
		},
		//positioning adjustments to be made when the popper is shown
		makeAdjustments() {
			this.appendArrowOverlay();
			//commenting out this workaround as to address the issue with a permenant fix if it occurs
			// this.makeWider();
		},
		//Applies a custom class for index popovers that are not appearing in the correct place
		//Makes the tooltip wider and also adjust the top value
		makeWider() {
			if (this.$el.classList.contains('wide')) {
				const popper = this.$refs.popper;
				const iballValue =
					popper.hasAttribute('iball') &&
					popper.getAttribute('iball');
				if (iballValue === '249' || iballValue === '239') {
					popper.classList.add('wide');
				}
			}
		},
		revertZIndex() {
			if (this.$route.name === 'Returns') {
				this.$el.closest('td').style = '';
			}
		}
	}
};
</script>
<style lang='less'>
.afis-icon-iball {
	font-size: 14px;
	color: #48baff;
	&::after {
		content: ' ';
		font-size: 0.666em;
	}
}
.v-popper__popper {
	padding: 10px;
}
.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-inner {
	top: 4px;
}
.v-popper__popper[data-popper-placement^=bottom] .v-popper__arrow-outer {
	left: -2px;
	border-width: 7px;
	top: -4px;
}
.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-outer {
	left: -2px;
	border-width: 7px;
}
.v-popper__popper[data-popper-placement^=top] .v-popper__arrow-inner {
	top: -1px;
}
.v-popper__arrow-inner {
	visibility: visible !important;
	border-color: white !important;
}
.v-popper__arrow-outer {
	border-color: #999 !important;
}
.v-popper__wrapper {
	max-width: 305px;
	min-width: 32px;
	min-height: 26px;
}
.v-popper__inner {
	background-color: #fff !important;
	color: rgb(33,33,33) !important;
	box-shadow: none;
	border: 1px #999 solid;
	padding: 6px !important;
	font-size: 12px;
	line-height: 13px;
	font-family: AvenirNextLTW01-Regular, Arial;
	text-align: left;
	white-space: normal;
}
</style>
